var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canImpersonate && !_vm.isImpersonating)?_c('b-dropdown-item',{attrs:{"to":{ name: 'impersonate' }}},[_vm._v("\n  Impersonate\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }